module.exports = {
  'cp_title': 'Customer Portal',
  'cp_appointment_details': 'Appointment Details',
  'cp_select_date': 'Select Date',
  'cp_available_time_slots': 'Available Time Slots',
  'cp_confirm_and_submit': 'Confirm & Submit',
  'cp_appointment_successfully_booked': 'Appointment Successfully Booked',
  'cp_will_receive_email': 'You will receive an email confirming your appointment',
  'cp_login': 'Login',
  'cp_welcome': 'Welcome to our customer portal',
  'cp_confirmation_number': 'Confirmation number',
  'cp_enter_confirmation_number': 'Enter confirmation number to send One Time Passcode',
  'cp_otp': 'One Time Passcode',
  'cp_enter_otp': 'Enter One Time Passcode',
  'cp_progress_tracking': 'Progress Tracking',
  'cp_reschedule': 'Reschedule',
  'cp_cancel_appointment': 'Cancel Appointment',
  'cp_reschedule_confirm_title': 'Are you sure you want to reschedule?',
  'cp_reschedule_confirm_copy': 'We will keep the current schedule until you confirm the new date and time.',
  'cp_cancel_appointment_confirm_title': 'Are you sure you want to cancel your appointment?',
  'cp_cancel_appointment_confirm_copy': 'Be aware this action cannot be undone',
  'cp_cancel': 'Cancel',
  'cp_yes_reschedule': 'Yes, reschedule',
  'cp_yes_cancel': 'Yes, Cancel',
  'cp_appointment_successfully_cancelled': 'Appointment Successfully Cancelled',
  'cp_will_receive_cancel_email': 'You will receive an email confirming your cancelation',
  'cp_fallback_error': 'Something went wrong, please try again later',
  'cp_service': 'Service',
  'cp_address': 'Address',
  'cp_appointment_date_time': 'Appointment Date & Time',
  'cp_error_title': 'Oh no, there was an error',
  'cp_error_copy': 'Please contact customer care to sort it out',
  'cp_cancel_cancel_appointment_offline': 'Please reach out to our call center {phone} to cancel your appointment. The  appointment status will be updated once you speak to a representative.',
  'cp_resend_otp':'Resend One Time Passcode in',
  'cp_get_otp': 'Get One Time Passcode',
  'cp_otp_error': 'The Confirmation Number or One Time Passcode is not valid. Please try again',
  'cp_powered_by_zinier': 'Powered By Zinier',
  'terms_and_conditions_link': 'https://www.zinier.com/terms',
  'privacy_policy_link': 'https://www.zinier.com/privacy-policy-app/',
  'cp_terms_label': 'Terms & Conditions',
  'cp_privacy_policy_label': 'Privacy Policy',
  'cp_track_your_appointment': 'Track your appointment',
  'cp_confirm_appointment': 'Confirm appointment',
  'cp_apppointment_details_additional_info_submit': 'Submit',
  'cp_task_cancelled' : 'This appointment has already been cancelled. Please contact support in case of any concerns.',
  'cp_appointment_cancelled' : 'Appointment cancelled',
  'cp_slot_not_available' : 'The selected appointment is no longer available. Please select another appointment',
  'cp_something_went_wrong' : 'Something went wrong!',
  'cp_something_unexpected_happened' : 'Looks like something unexpected happened. You can wait a bit and try again.',
  'cp_new_request_sent' : 'New Access Request Sent',
  'cp_new_request_message' : 'Your new access request has been successfully received. Please check your email for the new invitation. Feel free to close this page.',
  'cp_link_expired' : 'Link Expired',
  'cp_request_new_access' : 'Click on the button below to request for a new access link',
  'cp_request_access_btn' : 'Request New Access',
  'cp_no_options_available': 'No Options Available',
  'cp_work_order': 'Work Order',
  'cp_need_help': 'Need help?',
  'cp_contact_your_main_contractor': 'Contact your main contractor',
  'cp_link': 'link',
  'cp_reference': 'Reference',
  'cp_status': 'Status',
  'cp_in_progress': 'In Progress',
  'cp_tasks': 'Tasks',
  'cp_details': 'Details',
  'cp_review_report': 'Review report',
  'cp_completed': 'Completed',
  'cp_status_open': 'Open',
  'cp_status_accepted': 'Accepted',
  'cp_status_completed': 'Completed',
  'cp_status_pending_review': 'Pending review',
  'cp_acknowledgement_needed': 'Your acknowledgement is needed',
  'cp_technician_on_the_way': 'Technician on the way',
  'cp_review_task_banner': 'One task needs your review. Review it to keep your installation on track.',
  'cp_task': 'Task',
  'cp_appointment_created': 'Appointment Created',
  'cp_confirm_booking': 'Confirm Booking',
  'cp_task_assigned_scheduled': 'Task Assigned & Scheduled',
  'cp_task_dispatched': 'Task Dispatched',
  'cp_action_required': 'Action required',
  'cp_report_review': 'Report Review',
  'cp_report_ready_for_review': 'Your report is ready for review. Download it, and confirm whether the work was completed as agreed.',
  'cp_report_reviewed_confirm': 'Yes, I have reviewed the report and the work carried out.',
  'cp_acknowledge_report': 'Acknowledge report',
  'cp_reject_report': 'Reject report',
  'cp_download': 'Download',
  'cp_acknowledge': 'Acknowledge',
  'cp_acknowledge_report_title': 'Acknowledge report?',
  'cp_acknowledge_report_copy': 'This confirms the work was completed as described. We\'ll close the appointment and email you a copy.',
  'cp_reject_report_title': 'Reject report?',
  'cp_reject_report_copy': 'The appointment stays open and won\'t be closed. Your reason is sent to the service team for review.',
  'cp_whats_the_problem': 'What\'s the problem?',
  'cp_reject_reason_placeholder': 'Tell us what wasn\'t completed or what isn\'t right',
  'cp_report': 'Report',
  'cp_report_acknowledged': 'Report Acknowledged',
  'cp_report_acknowledged_copy': 'Your service is complete and this appointment is now closed.',
  'cp_report_rejected': 'Report Rejected',
  'cp_report_rejected_copy': 'This appointment stays open while the service team reviews your report.',
  'cp_copy_emailed_to': 'A signed copy was emailed to',
  'cp_response_emailed_to': 'A copy of your response was emailed to',
  'cp_what_was_the_problem': 'What was the problem?',
  'cp_verify_its_you': 'Verify it\'s you',
  'cp_verify_copy': 'Before signing, enter the 6-digit code we sent to {email}. The code expires in 10 minutes.',
  'cp_verify_copy_no_email': 'Before signing, enter the 6-digit code we sent to your email. The code expires in 10 minutes.',
  'cp_verification_code': 'Verification code',
  'cp_resend_code': 'Resend Code',
  'cp_confirm': 'Confirm',
  'cp_job_location': 'Job Location',
  'cp_tasks_copy': 'Your tasks are listed below. Tap each to see details.',
  'cp_close': 'Close',
  'cp_subcontractor': 'Subcontractor',
  'cp_appointment_window': 'Appointment Window',
  'cp_technician': 'Technician',
  'cp_what_is_this': 'What is this?',
  'cp_main_contractor': 'Main Contractor',
  'cp_view_progress': 'View progress',
  'cp_general_questions': 'If you have general questions you can contact us via this',
  'cp_booking_created': 'Booking Created',
  'cp_work_in_progress': 'Work in progress',
  'cp_review_in_progress': 'Review in progress',
  'cp_work_completed': 'Work completed'
}
